import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f6f8de44&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f6f8de44&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=f6f8de44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f8de44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6f8de44')) {
      api.createRecord('f6f8de44', component.options)
    } else {
      api.reload('f6f8de44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f6f8de44&scoped=true&", function () {
      api.rerender('f6f8de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SettingsBottom/index.vue"
export default component.exports